import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PageSenseService {

  static trackUser(user: { userId: string; name: string }): void {
    try {
      const win = window as any;
      // PageSense not loaded
      if (!win.pagesense) {
        console.warn('[PageSense] pagesense object not found');
        return;
      }
      // PageSense loaded but not an array or push missing
      if (!Array.isArray(win.pagesense) || typeof win.pagesense.push !== 'function') {
        console.warn('[PageSense] pagesense is not initialized correctly.');
        return;
      }
      win.pagesense.push([
        'trackUser',
        {
          userId: user.userId,
          name: user.name
        }
      ]);
    } catch (error) {
      console.warn('[PageSense] trackUser failed.', error);
    }
  }
}
